<template>
  <div class="header">
    <div class="title">
      <div>
        <h2>
          {{$ml.get(`Fertilizer Schedule`)}}
        </h2>
        <info-tip :title="$ml.get(`Here you need to select the fertilizers that are available in your farm`)" />
        <!-- <info-tip :title="$ml.get(`Here you need to select the fertilizers that are available in your farm`)" /> -->
      </div>

      <div class="buttons">
        <app-btn
          :class="{'--pulse': (flag !== null && flag <= 0)}"
          @click="openPopup = !openPopup"
          :disabled="$store.getters['program/data'].finished"
        >
          {{$ml.get(`SELECT FERTILIZER`)}}
        </app-btn>
      </div>
    </div>

    <div class="stripe" v-if="flag > 0">
      <div class="filter">
        <span>{{$ml.get(`Recommendation per`)}}:</span>
        <app-sel
          styling="inline"
          key-name="key"
          v-model="stage"
          :items="stageItem"
        >
          <template v-slot="{ items }">
            <app-sel-opt
              :value="item"
              v-for="(item, j) in items"
              :key="j"
            >
              {{ item.label }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>
      <app-btn
        styling="outline"
        w-auto
        @click="manualEvent"
        :disabled="$store.getters['program/data'].finished"
      >
        <template v-if="!manual">
          {{$ml.get(`MANUAL ADJUSTMENT`)}}
        </template>
        <template v-else>
          {{$ml.get(`save`)}}
        </template>
      </app-btn>

    </div>

    <selectFertilizer :open="openPopup" v-model="fertilizers" :programm="true" @updateFertilizers="update" />
  </div>
</template>

<script>
import SelectFertilizer from "@/components/program/fertilizerSel/SelectFertilizer.vue"

export default {
  props: {
    manual: Boolean,
    flag: Number
  },
  data() {
    return {
      stage: 'stage',
      stageItem: [
        {
          key: 'stage',
          label: this.$ml.get(`Stage`),
        },
        {
          key: 'day',
          label: this.$ml.get(`Day`),
        },
        {
          key: 'week',
          label: this.$ml.get(`Week`),
        },
      ],
      openPopup: true,
      fertilizers: []
    }
  },
  components: {
    SelectFertilizer
  },
  watch: {
    stage: function (val) {
      if (!this.manual || this.stage == 'stage') {
        this.$emit('input', val);
      } else {
        this.stage = 'stage';
      }
    },
  },
  methods: {
    print: function () {
      this.$emit('printEvent');
    },
    manualEvent: function () {
      this.stage = 'stage';
      this.$emit('manualEvent');
    },
    update: function () {
      this.$store.dispatch('program/steps/setCurrentStep', 'fertilizer-schedule').then(res => {
        this.$emit('upEvent');
      });
      // this.$store.dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'fertilizer-schedule');
    }
  }
}
</script>

<style lang="scss" scoped>

.header {
  // padding-top: 50px;

  .title {
    width: 100%;
    font-size: 22px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 32px 0;

    & > div:first-child {
      font-size: 22px;
      font-weight: bold;
      display: flex;
      align-items: center;
    }

    .buttons {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      > * {
        margin: 5px 0;
        margin-left: 15px;
      }
    }
  }

  .stripe {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 33px 0 15px 0;

    .filter {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 500;
      font-family: Roboto;

      span {
        margin-right: 10px;
      }
      .app-sel {
        width: 120px;
      }
    }
  }
  @media (max-width:768px) {
    .title {
      flex-direction: column;
      align-items: flex-start;
      margin-top: 0;
      .buttons {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        > * {
          margin: 0 0 12px 0;
        }
      }
    }
    .stripe {
      flex-direction: column;
      align-items: flex-start;
      .filter {
        margin-bottom: 12px;
      }
    }
  }
}

</style>
